module.exports = __webpack_public_path__ + "static/media/error.8cb8cfce.svg";